let instance = null;

export const setLenis = (l) => {
  instance = l;
};

export const getLenis = () => instance;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (instance) instance.scrollTo(el, { offset: -10, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
